<template>
  <img v-if="attendee.logo" :src="attendee.logo" :alt="attendee.full_name"
    class="rounded-full object-cover flex-shrink-0" :class="sizeClass"/>
  <div v-else
    class="rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0"
    :class="sizeClass"
    :style="{ backgroundColor: avatarColor(attendee.email) }">
    {{ attendee.avatar_name }}
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  attendee: { type: Object, required: true },
  size: { type: String, default: 'md' }, // 'sm' | 'md'
})

const sizeClass = computed(() => (props.size === 'sm' ? 'w-9 h-9' : 'w-10 h-10'))

// Deterministic per-email colour so the same person keeps the same avatar
// across the global attendees page and every per-event tab.
const AVATAR_COLORS = ['#2563eb', '#7c3aed', '#059669', '#d97706', '#dc2626', '#0891b2', '#be185d']

function avatarColor(email) {
  let hash = 0
  const value = email || ''
  for (let i = 0; i < value.length; i++) hash = value.charCodeAt(i) + ((hash << 5) - hash)
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}
</script>
